import React from 'react';

import MainHeader from '../MainHeader/MainHeader';
import MainFooter from '../MainFooter/MainFooter';

import styles from './PageWithHeader.module.css';

const PageWithHeader = (props) => {
  const { children } = props;
  return (
    <div className={styles.wrapper}>
      <MainHeader />
      <div className={styles.content}>
        {children}
      </div>
      <MainFooter />
    </div>
  );
};

export default PageWithHeader;